import CommonUiModel from "../common/commonUiModel";

const hookupConfig = {
    title: "Connector",
    api: "HookupConfig",
    navigateBack: -1,
    hideBreadcrumbInGrid: true,
    module: 'ScopeMaster',
    showHistory: false,
    // permissions: { edit: true, add: true, delete: true },
    columns: [
        { field: 'ScopesPerBasin', label: 'Scopes Per Basin', type: 'number', width: 150, min: 1, max: '{MaxScopesPerBasin}', required: true, pinned: "left" },
        { field: 'EquipmentScopeId', type: 'number', gridLabel: "Equipment Scope", width: 200, label: null },
        { field: 'Notes', label: "Notes", multiline: true }
    ]
};

const HookupConfig = new CommonUiModel(hookupConfig);
export { hookupConfig };
export default HookupConfig;